import { Component } from 'react';
import numeral from 'numeral';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { inject } from 'mobx-react';
import TableHeadComponent from '../../shared_components/TableHeadComponent';
import TableBodyComponent from '../../shared_components/TableBodyComponent';

class LoanpartSummaryComponent extends Component {
  render() {
    /*
     *  Merge selectedLoanpartsPostData and loanpartsTotals
     * */
    const copyMortgageForm = { ...this.props.CalculationFormData.mortgageForm };
    const selectedLoanpartsPostData = copyMortgageForm.loanpartsPostData;

    const { loanparts, nhg, forceAutoRiskClassReduction } = copyMortgageForm;
    const {
      loanpartDurationLabels,
      selectedLabelHasAutoRiskClassReduction,
      mortgageTypes,
    } = this.props.CalculationFormData;

    const labelHasAutoRiskClassReduction = selectedLabelHasAutoRiskClassReduction();

    const { loanpartsTotals, calculationResponse, shallowFormDataCopy } = this.props.CalculationOutputData;

    const rowData = selectedLoanpartsPostData.map((loanpartPostItem, index) => {
      let mortgageType;
      let loanpartDuration;

      if (loanpartPostItem.mortgageType) {
        const selectedMortgageType = mortgageTypes.find(type => type.value === Number(loanpartPostItem.mortgageType));
        mortgageType = _.has(selectedMortgageType, 'name') ? selectedMortgageType.name : '';
      }

      if (loanpartPostItem.loanpartDuration) {
        const selectedLoanPartDuration =
          loanpartDurationLabels.find(duration => duration.value === Number(loanpartPostItem.loanpartDuration));
        loanpartDuration = _.has(selectedLoanPartDuration, 'name') ? selectedLoanPartDuration.name : '';
      }

      const frt = loanpartPostItem.frt ? `${loanpartPostItem.frt} jaar` : '';
      const gross = numeral(loanparts[index]).format('$ 0,00.00');
      let initialInterest;
      let averageInterest;
      let fixedRateTerm;

      if (loanpartsTotals.length >= index + 1) {
        initialInterest = numeral(loanpartsTotals[index].initialInterest / 100).format('%0.00');
        averageInterest = numeral(loanpartsTotals[index].averageInterest / 100).format('%0.00');
        averageInterest = ((labelHasAutoRiskClassReduction && !nhg)
          || forceAutoRiskClassReduction) ? averageInterest : '-';
        fixedRateTerm = numeral(loanpartsTotals[index].fixedRateTerm / 100).format('%0.00');
        fixedRateTerm = ((labelHasAutoRiskClassReduction && !nhg)
          || forceAutoRiskClassReduction) ? fixedRateTerm : '-';
      }
      const loanpart = `Leningdeel ${index + 1}`;

      let loanpartRow;

      if (shallowFormDataCopy.loanparts.length >= index + 1) {
        loanpartRow = {
          loanpart,
          mortgageType,
          frt,
          loanpartDuration,
          gross,
          initialInterest,
          averageInterest,
          fixedRateTerm,
        };
      }

      return loanpartRow;
    });

    const total = _.get(calculationResponse, 'data.total.total');

    const initialInterest = total ? numeral(total.initialInterest / 100).format('%0.00') : '';
    let averageInterest = total ? numeral(total.averageInterest / 100).format('%0.00') : '';
    averageInterest = ((labelHasAutoRiskClassReduction && !nhg)
      || forceAutoRiskClassReduction) ? averageInterest : '-';
    // const fixedRateTerm = total ? numeral(total.fixedRateTerm / 100).format('%0.00') : '';

    const dutchColumnNames = [
      'Leningdeel',
      'Bedrag',
      'Vorm',
      'Rentevaste periode',
      'Looptijd leningdeel',
      'Aanvangsrente',
      'Looptijdrente',
      'Looptijdrente rentevaste periode',
    ];

    /* Set column names for order and selection of rowdata */
    const columnNames = [
      'loanpart',
      'gross',
      'mortgageType',
      'frt',
      'loanpartDuration',
      'initialInterest',
      'averageInterest',
      'fixedRateTerm',
    ];

    return (
      <div className="calculation-container__loanpart-summary-wrapper tool-row columns">
        <table className="calculation-container__loanpart-summary">
          <TableHeadComponent columnNames={dutchColumnNames} />
          <TableBodyComponent
            columnNames={columnNames}
            rowData={rowData}
          />
          <tfoot>
            <tr>
              <td>Totaal</td>
              <td />
              <td />
              <td />
              <td />
              <td>{initialInterest}</td>
              <td>{averageInterest}</td>
              <td>-</td>
            </tr>
          </tfoot>
        </table>
        <div className="row calculation-container__loanpart-summary__shadow" />
      </div>
    );
  }
}

LoanpartSummaryComponent.propTypes = {
  CalculationOutputData: PropTypes.shape({
    shallowFormDataCopy: PropTypes.shape({}),
    riskClassReductionDates: PropTypes.func,
    loanpartsTotals: PropTypes.oneOfType([
      PropTypes.shape({}),
      PropTypes.arrayOf(PropTypes.shape({})),
    ]),
    calculationResponse: PropTypes.oneOfType([
      PropTypes.shape({}),
      PropTypes.arrayOf(PropTypes.shape({})),
    ]),
  }),
  CalculationFormData: PropTypes.shape({
    loanpartDurationLabels: PropTypes.oneOfType([
      PropTypes.shape({}),
      PropTypes.arrayOf(PropTypes.shape({})),
    ]),
    selectedLabelHasAutoRiskClassReduction: PropTypes.func,
    mortgageTypes: PropTypes.oneOfType([
      PropTypes.shape({}),
      PropTypes.arrayOf(PropTypes.shape({})),
    ]),
    mortgageForm: PropTypes.shape({
      loanparts: PropTypes.arrayOf(PropTypes.number),
      loanpartsPostData: PropTypes.arrayOf(PropTypes.shape({})),
    }),
  }),
};

LoanpartSummaryComponent.defaultProps = {
  loanpartDurationLabels: [],
  mortgageTypes: [],
  CalculationOutputData: {
    shallowFormDataCopy: {},
  },
  riskClassReductionDates: () => {},
  CalculationFormData: {
    selectedLabelHasAutoRiskClassReduction: () => {
    },
  },
};

export default inject('CalculationOutputData', 'CalculationFormData')(LoanpartSummaryComponent);
